/** Floating surface shared by Popover, Menu and ContextMenu. */
import { vars } from '@planner/tokens/css';
import { keyframes, style } from '@vanilla-extract/css';

const enter = keyframes({ from: { opacity: 0, transform: `translateY(calc(${vars.space['1']} * -1))` } });
const exit = keyframes({ to: { opacity: 0 } });

export const surface = style({
  zIndex: vars.zIndex.popover,
  maxWidth: vars.size.popoverMax,
  backgroundColor: vars.color.bg.surfaceRaised,
  color: vars.color.text.default,
  border: `${vars.borderWidth.hairline} solid ${vars.color.border.default}`,
  borderRadius: vars.radius.lg,
  boxShadow: vars.shadow.lg,
  outline: 'none',
  selectors: {
    '&[data-entering]': { animation: `${enter} ${vars.motion.duration.fast} ${vars.motion.easing.standard}` },
    '&[data-exiting]': { animation: `${exit} ${vars.motion.duration.fast} ${vars.motion.easing.exit}` },
  },
});

export const dialog = style({
  padding: vars.space['3'],
  outline: 'none',
  fontSize: vars.font.size.md,
});

export const title = style({
  marginBottom: vars.space['2'],
  fontSize: vars.font.size.md,
  fontWeight: vars.font.weight.semibold,
});

export const arrow = style({
  display: 'block',
  fill: vars.color.bg.surfaceRaised,
  stroke: vars.color.border.default,
  strokeWidth: vars.borderWidth.hairline,
  selectors: {
    '[data-placement="bottom"] &': { transform: 'rotate(180deg)' },
    '[data-placement="right"] &': { transform: 'rotate(90deg)' },
    '[data-placement="left"] &': { transform: 'rotate(-90deg)' },
  },
});
